import React from 'react';
import { Section } from '../ui/Section';
export function Proof() {
  return <Section theme="onyx" className="border-b border-gold-hairline" data-id="element-137">
      <div className="max-w-4xl mx-auto text-center" data-id="element-138">
        <h2 className="text-3xl md:text-5xl font-serif font-medium mb-16 text-bone leading-tight" data-id="element-139">
          In 2026, the gap between "Auction Value" and "Zillow Value" has
          reached an all-time high.
        </h2>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-140">
          <div className="bg-black p-8 border border-gold-hairline shadow-editorial-dark" data-id="element-141">
            <div className="text-4xl md:text-5xl font-serif font-medium text-gold mb-4" data-id="element-142">
              105%
            </div>
            <div className="text-xs font-semibold tracking-[0.2em] text-gold-soft uppercase mb-6" data-id="element-143">
              Of Asking Price
            </div>
            <p className="text-bone-muted text-sm leading-relaxed" data-id="element-144">
              What the average buyer is paying on the MLS right now.
            </p>
          </div>

          <div className="bg-graphite p-8 border border-gold/40 shadow-editorial-dark transform md:-translate-y-4" data-id="element-145">
            <div className="text-4xl md:text-5xl font-serif font-medium italic text-gold mb-4" data-id="element-146">
              60-70¢
            </div>
            <div className="text-xs font-semibold tracking-[0.2em] text-gold uppercase mb-6" data-id="element-147">
              On The Dollar
            </div>
            <p className="text-bone text-sm leading-relaxed" data-id="element-148">
              What savvy Protocol users are paying for "Subject-To" and "Tax
              Deed" properties.
            </p>
          </div>

          <div className="bg-black p-8 border border-gold-hairline shadow-editorial-dark" data-id="element-149">
            <div className="text-4xl md:text-5xl font-serif font-medium text-gold mb-4" data-id="element-150">
              7 Days
            </div>
            <div className="text-xs font-semibold tracking-[0.2em] text-gold-soft uppercase mb-6" data-id="element-151">
              Time to Results
            </div>
            <p className="text-bone-muted text-sm leading-relaxed" data-id="element-152">
              See more viable, cheap properties than you've seen in three years
              of browsing Zillow.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}